import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-telefone1',
  templateUrl: './text-telefone1.component.html',
  styleUrls: ['./text-telefone1.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextTelefone1Component implements OnInit {

  constructor() {}

  ngOnInit() {}

}
